import HttpUtils from "../utils/HttpUtils";

/**
 * 记录访问量（对接后端 /web/access/record）
 * @param {string} projectCode 项目编码
 * @param {string} projectName 项目名称
 * @param {string} accessPath 访问路径
 */
const  recordAccess = ( accessPath: string) => {
  // 默认值
  const DEFAULT_PROJECT_CODE = 'qzkt_web'       // 默认项目编码
  const DEFAULT_PROJECT_NAME = 'study.ooowin.com'         // 默认项目名称
  return HttpUtils.post("/web/access-statistics/record", {
    projectCode: DEFAULT_PROJECT_CODE,
    projectName: DEFAULT_PROJECT_NAME,
    accessPath: accessPath || window.location.pathname,
  })
}


const CommonService = {
  recordAccess
}

export default CommonService;